/**
 * Shared display-label logic for the PDF "Field in data source" dropdowns.
 *
 * The dropdown's option `value` is the unique extracted DTO key; the visible
 * label comes from the LLM's fieldMappingMetadata `sourceField`. Several DTO
 * keys can share the same sourceField (e.g. multiple fields inferred from one
 * unlabeled supplier/header block all get "Supplier Name"), which produced
 * several visually-identical dropdown entries the user could not tell apart.
 *
 * `rawSourceLabel` reproduces the original (sourceField || key, capped 80).
 * `disambiguateSourceLabel` appends the DTO key when a label collides with
 * another header in the same list, so duplicates become distinguishable
 * ("Supplier Name (SupplierName)", "Supplier Name (Brand)", …).
 */

// Original label: sourceField if present, else the key itself, capped to 80 chars.
export function rawSourceLabel(header, sourceLabels) {
  return ((sourceLabels && sourceLabels[header]) || String(header)).slice(0, 80);
}

// Disambiguated label: same as rawSourceLabel unless another header in
// `allHeaders` resolves to the same label, in which case the DTO key is
// appended to make the option distinguishable.
export function disambiguateSourceLabel(header, sourceLabels, allHeaders) {
  const label = rawSourceLabel(header, sourceLabels);
  const headers = Array.isArray(allHeaders) ? allHeaders : [];
  const collisions = headers.filter((h) => rawSourceLabel(h, sourceLabels) === label).length;
  if (collisions <= 1) return label;
  return `${label} (${String(header)})`.slice(0, 80);
}
